import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  AlertController,
  ToastController
} from "ionic-angular";
import { DatabaseProvider } from "../../providers/database/database";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/mergeMap";
import { AuthProvider } from "../../providers/auth/auth";

@IonicPage()
@Component({
  selector: "page-admin-doctors",
  templateUrl: "admin-doctors.html"
})
export class AdminDoctorsPage {

  public doctorsList: Observable<any[]>;
  clinic_name: string;
  clinic_id: string;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private readonly auth: AuthProvider,
    public database: DatabaseProvider,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController
  ) {
    this.auth.getCurrentUser().then(user => {

      this.clinic_name = user.clinic_name;
      this.clinic_id = user.clinic_id;

      this.doctorsList = this.database
      .getDoctors()
      .snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      });
    });
  }

  ionViewDidLoad() {}

  add() {
    
  }
}



// WEBPACK FOOTER //
// ./src/pages/admin-doctors/admin-doctors.ts